/**
 * Validates base64 string (pattern + atob). Returns true if valid.
 * Optionally shows toast on error when showToast is provided.
 */
export function validateBase64(
  str: string | null | undefined,
  showToast?: (type: "error" | "success", message: string) => void
): boolean {
  if (!str) {
    return false;
  }
  const base64Regex = /^([A-Za-z0-9+/]{4})*([A-Za-z0-9+/]{3}=|[A-Za-z0-9+/]{2}==)?$/;
  if (!base64Regex.test(str)) {
    showToast?.("error", "Invalid base64 string");
    return false;
  }
  try {
    if (typeof window !== "undefined") {
      window.atob(str);
    }
    return true;
  } catch {
    showToast?.("error", "Invalid base64 string");
    return false;
  }
}

/**
 * Validates that a value is a valid number. Returns the number or null if invalid.
 * Optionally shows toast when showToast is provided.
 */
export function validateNumberField(
  fieldValue: unknown,
  fieldName: string,
  showToast?: (type: "error" | "success", message: string) => void
): number | null {
  const value = Number(fieldValue);
  if (isNaN(value)) {
    showToast?.("error", `${fieldName} should be a valid number`);
    return null;
  }
  return value;
}
